/* By Lilo — maakt van de FAQ-pagina-inhoud (h3 vraag + volgende tekst = antwoord)
   een accordeon, en genereert FAQPage structured data. Behoudt de echte content
   (SEO) en h2-categoriekoppen. */
(function () {
  function init() {
    var root = document.querySelector('.bl-faq-page__content');
    if (!root || root.dataset.blInit) return;
    root.dataset.blInit = '1';

    var nodes = Array.prototype.slice.call(root.childNodes);
    var faqLd = [];
    var current = null; // accordeongroep onder een h2

    // Bouw opnieuw op: h1/h2 blijven, elke h3 wordt een <details> met het antwoord erin
    var frag = document.createDocumentFragment();
    var i = 0;
    var container = null; // .bl-faq-page__group

    function ensureGroup() {
      if (!container) {
        container = document.createElement('div');
        container.className = 'bl-faq-page__group';
        frag.appendChild(container);
      }
      return container;
    }

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && /^H1$/i.test(node.tagName)) {
        node.classList.add('bl-faq-page__title');
        frag.appendChild(node);
        container = null;
        current = null;
      } else if (node.nodeType === 1 && /^H2$/i.test(node.tagName)) {
        node.classList.add('bl-faq-page__cat');
        frag.appendChild(node);
        container = null;
        current = null;
      } else if (node.nodeType === 1 && /^H3$/i.test(node.tagName)) {
        // start nieuwe accordeon-item
        var det = document.createElement('details');
        det.className = 'bl-faq__item';
        var sum = document.createElement('summary');
        sum.innerHTML = node.innerHTML + '<span class="bl-faq__icon" aria-hidden="true"></span>';
        det.appendChild(sum);
        var body = document.createElement('div');
        body.className = 'bl-faq__answer';
        det.appendChild(body);
        det._answer = body;
        det._question = node.textContent.trim();
        ensureGroup().appendChild(det);
        current = det;
      } else {
        // hoort bij het huidige antwoord
        if (current) {
          current._answer.appendChild(node.cloneNode(true));
        } else {
          frag.appendChild(node.cloneNode ? node.cloneNode(true) : node);
        }
      }
    });

    // Verzamel JSON-LD
    frag.querySelectorAll && frag.querySelectorAll('.bl-faq__item').forEach(function (det) {
      var ans = det._answer ? det._answer.textContent.trim() : '';
      if (det._question && ans) {
        faqLd.push({ '@type': 'Question', name: det._question, acceptedAnswer: { '@type': 'Answer', text: ans } });
      }
    });

    root.innerHTML = '';
    root.appendChild(frag);

    if (faqLd.length) {
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faqLd });
      document.head.appendChild(s);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
